import React from 'react';
import { Form } from 'react-bootstrap';
import { FaKey } from 'react-icons/fa';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import AssignmentGrid from '../../components/AssignmentGrid/AssignmentGrid';

const RolePermissionForm = ({ handleSubmit, handleChange, selectAllPermissionHandler,
  permissionHandler, formData }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-12 mb-3">
          <Input
            label="Role Name"
            type="text"
            name="name"
            placeholder="Enter role name"
            value={formData.name}
            onChangeHandler={handleChange}
            required={true}
          />
        </div>
      </div>
      <div className="row">
        <AssignmentGrid
          label="Permissions"
          icon={<FaKey />}
          items={formData.permissionData || []}
          selectedIds={formData.permissions || []}
          onSelectAll={selectAllPermissionHandler}
          onToggle={(event) => permissionHandler(event, event.target.value)}
          switchName="permissions"
        />
      </div>
      <div className="col-md-12 d-flex justify-content-end mt-3">
        <div>
          <Button variant="success" type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default RolePermissionForm;
